import { type FC, useCallback } from 'react';
import { Button, type TestProps } from '@direct-frontend/components';
import { useFormContext } from '@adv-frontend/form-kit';
import { usePreviewWidget } from '../../../../lib/previewWidget';
import { changeVariantPriceTooltipForm } from '../../model';

type ShowDiscountButtonProps = {
    formId: string;
    className?: string;
} & TestProps;

export const ShowDiscountButton: FC<ShowDiscountButtonProps> = ({
    formId,
    className,
    'data-testid': dataTestId = 'ShowDiscountButton',
}) => {
    const formContext = useFormContext({ form: changeVariantPriceTooltipForm, id: formId });
    const { setOpen } = usePreviewWidget();
    const handleClick = useCallback(() => {
        if (!formContext.discount) {
            return;
        }

        setOpen(`discount-automatic/${formContext.discount.id}`, formContext.discount);
    }, [formContext.discount, setOpen]);

    return (
        <Button
            isDisabled={!formContext.discount}
            onClick={handleClick}
            color="normal"
            className={className}
            data-testid={dataTestId}
            size="xs"
        >
            Показать акцию
        </Button>
    );
};
